<a mat-raised-button color="primary" (click)="downloadTemplate()">
  <mat-icon>cloud_download</mat-icon>
  Planungs-Excel-Vorlage herunterladen
</a>
